<template>
    <b-modal size="xl"
             centered
             hide-footer
             content-class="rounded-xl border-0 shadow-lg"
             v-bind:visible="value"
             v-on:hide="hideModal"
             v-on:cancel="hideModal"
             v-on:close="hideModal">
        <template v-slot:modal-title>
            <strong>
                {{ isEditing ? "編輯橫幅" : "新增橫幅"  }}
            </strong>
        </template>

        <form v-on:submit.prevent.stop="save"
              v-on:reset.prevent.stop="reset">
            <div class="banner position-relative card d-flex flex-row align-items-center bg-light rounded-xl overflow-hidden px-3 py-5 mb-3"
                 v-bind:class="bannerClass">
                <div class="position-absolute banner-image">
                    <img class="background position-absolute h-100 w-100"
                         alt="banner"
                         v-if="image"
                         v-bind:src="image">
                    <img class="main position-relative h-100 w-100"
                         alt="banner"
                         v-if="image"
                         v-bind:src="image">
                </div>
                <div class="position-absolute buttons pt-2 pr-2">
                    <label class="btn btn-sm btn-outline-dark rounded-pill shadow-sm"
                           for="image">
                        <font-awesome-icon v-bind:icon="['fad', 'image']"></font-awesome-icon>
                        選擇圖片
                        <input id="image"
                               class="d-none"
                               type="file"
                               accept="image/*"
                               v-on:change="handleImage">
                    </label>
                </div>
                <div class="banner-details rounded-xl p-3"
                     v-bind:class="{ 'active': !!image }">
                    <div class="form-row">
                        <b-form-group class="col-sm-6"
                                      label-for="alignment">
                            <template v-slot:label>
                                <strong>對齊</strong>
                            </template>
                            <b-form-select id="alignment"
                                           size="sm"
                                           v-model="alignment">
                                <b-form-select-option value="left">
                                    靠左
                                </b-form-select-option>
                                <b-form-select-option value="center">
                                    置中
                                </b-form-select-option>
                                <b-form-select-option value="right">
                                    靠右
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group class="col-sm-12"
                                      label-for="slogan">
                            <template v-slot:label>
                                <strong>標語</strong>
                            </template>
                            <b-form-input id="slogan"
                                          size="sm"
                                          v-model="slogan">
                            </b-form-input>
                        </b-form-group>

                        <b-form-group>
                            <b-form-checkbox switch
                                             v-model="hasButton">
                                {{ hasButton ? "帶有連結按鈕" : "沒有連結按鈕" }}
                            </b-form-checkbox>
                        </b-form-group>

                        <template v-if="hasButton">
                            <div class="col-sm-12 mb-3">
                                <a class="btn btn-outline-dark px-4"
                                   target="_blank"
                                   v-bind:href="buttonLink">
                                    {{ buttonText ? buttonText : "TBA" }}
                                </a>
                            </div>
                            <b-form-group class="col-sm-12"
                                          label-for="button-text">
                                <template v-slot:label>
                                    <strong>連結文字</strong>
                                </template>
                                <b-form-input id="button-text"
                                              size="sm"
                                              v-bind:required="hasButton"
                                              v-model="buttonText">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group class="col-sm-12"
                                          label-for="button-link">
                                <template v-slot:label>
                                    <strong>按鈕連結</strong>
                                </template>
                                <b-form-input id="button-link"
                                              size="sm"
                                              v-bind:required="hasButton"
                                              v-model="buttonLink">
                                </b-form-input>
                            </b-form-group>
                        </template>
                    </div>
                </div>
            </div>
            <div class="text-center px-3">
                <button class="btn btn-secondary px-3 mr-2"
                        type="reset">
                    重設橫幅
                </button>
                <button class="btn btn-success px-3 mr-2"
                        type="submit">
                    {{ isEditing ? "編輯橫幅" : "新增橫幅"  }}
                </button>
            </div>
        </form>
    </b-modal>
</template>

<script>
import { apiUrl, apiNewVersion, } from "../../config";

import {
    BModal,
    BFormGroup, BFormInput,
    BFormCheckbox,
    BFormSelect, BFormSelectOption,
} from "bootstrap-vue";

export default {
    name: "ModalBanner",
    components: {
        BModal,
        BFormGroup, BFormInput,
        BFormCheckbox,
        BFormSelect, BFormSelectOption,
    },
    props: {
        "value": {
            type: Boolean,
            default: false,
        },
        "isEditing": {
            type: Boolean,
            default: false,
        },
        "banner": {
            type: Object,
        },
    },
    data () {
        return {
            hasButton: false,

            image: "",
            imageFile: null,
            alignment: "center",
            slogan: "",
            buttonText: "",
            buttonLink: "",
        };
    },
    computed: {
        bannerClass () {
            return this.alignment === "center" ?
                "justify-content-center" :
                this.alignment === "left" ?
                    "justify-content-start" :
                    "justify-content-end";
        },
    },
    methods: {
        hideModal () {
            this.$emit("input", false);
        },
        reset () {
            if (this.banner) {
                const { image, alignment, slogan, button: { text, link, }, } = this.banner;
                this.image = `${ apiUrl }/${ apiNewVersion }/banner/image/${ image }`;
                this.imageFile = null;
                this.alignment = alignment;
                this.slogan = slogan;
                this.buttonText = text;
                this.buttonLink = link;
                this.hasButton = this.buttonText && this.buttonLink;
                return;
            }
            this.image = "";
            this.imageFile = null;
            this.alignment = "center";
            this.slogan = "";
            this.buttonText = "";
            this.buttonLink = "";
            this.hasButton = this.buttonText && this.buttonLink;
        },
        async handleImage (e) {
            const temp = Array.from(e.target.files || e.dataTransfer.files);
            if (temp.length === 0) {
                return;
            }
            this.imageFile = temp[0];
            const reader = new FileReader();
            reader.readAsDataURL(temp[0]);
            this.image = await new Promise(
                resolve => {
                    reader.onload = (e) => {
                        resolve(e.target.result);
                    };
                }
            );
        },
        save () {
            if (this.isEditing) {
                this.update();
                return;
            }
            this.create();
        },
        async create () {
            const { alignment, slogan, imageFile, hasButton, buttonText, buttonLink, } = this;
            try {
                await this.$store.dispatch(
                    "banner/add",
                    {
                        alignment,
                        slogan,
                        "image": imageFile,
                        "button": {
                            "text": hasButton === true ? buttonText : null,
                            "link": hasButton === true ? buttonLink : null,
                        },
                    }
                );
            } catch (e) {
                console.error(e);
                return;
            }
            this.hideModal();
            this.reset();
        },
        async update () {
            const { alignment, slogan, imageFile, hasButton, buttonText, buttonLink, } = this;
            try {
                await this.$store.dispatch(
                    "banner/edit",
                    {
                        "_id": this.banner._id,
                        alignment,
                        slogan,
                        "image": imageFile,
                        "button": {
                            "text": hasButton === true ? buttonText : null,
                            "link": hasButton === true ? buttonLink : null,
                        },
                    },
                );
            } catch (e) {
                console.error(e);
                return;
            }
            this.hideModal();
            this.reset();
        },
    },
    mounted () {
        if (this.banner) {
            this.image = `${ apiUrl }/${ apiNewVersion }/banner/image/${ this.banner.image }`;
            this.imageFile = null;
            this.alignment = this.banner.alignment;
            this.slogan = this.banner?.slogan ?? "";
            this.buttonText = this.banner?.button?.text ?? "";
            this.buttonLink = this.banner?.button?.link ?? "";
            this.hasButton = this.buttonText && this.buttonLink;
        }
    },
    watch: {
        banner (newVal) {
            if (newVal) {
                this.image = `${ apiUrl }/${ apiNewVersion }/banner/image/${ newVal.image }`;
                this.imageFile = null;
                this.alignment = newVal.alignment;
                this.slogan = newVal?.slogan ?? "";
                this.buttonText = newVal?.button?.text ?? "";
                this.buttonLink = newVal?.button?.link ?? "";
                this.hasButton = this.buttonText && this.buttonLink;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.banner {
    min-height: 640px;
    box-shadow: inset 0 0.125rem 0.25rem rgba(0, 0, 0, 0.08);
}

.banner-image {
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    & > img {
        &.main {
            object-fit: contain;
            object-position: center center;
            z-index: 1;
        }

        &.background {
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;

            object-fit: cover;
            object-position: center center;
            filter: blur(5px);
            z-index: 0;
        }
    }
}

.banner-details {
    min-width: 320px;
    width: 60%;
    z-index: 9;
    transition:
        background-color 250ms ease-in-out,
        backdrop-filter 250ms ease-in-out;

    &.active {
        background-color: rgba(255, 255, 255, 0.5);
        backdrop-filter: blur(5px);
    }
}

.buttons {
    top: 0;
    right: 0;
    z-index: 10;
}

.btn-outline-dark {
    background-color: rgba(255, 255, 255, 1);

    &:hover {
        background-color: #343a40;
    }
}
</style>
